/*globals document, console, $, childLimit */

var rowTotal = 1,
    rowLimit = parseInt(childLimit, 10);

/**
 * Adds a new row to the defined parent using defined template in DOM
 * @class
 * @param   {object} e click event
 * @returns {object} public variables/methods
 */
var AddRow = function (e) {
    "use strict";

    // NOTE: all member variables and methods are PRIVATE unless otherwise noted

    var scope = this,
        event,
        button,   // @public
        template, // @public
        
        rowTotal,

        buttonID    = ".add-row-btn", // Make sure to include class (.) or id (#) definition, if applicable
        templateID  = "data-row-template", // Has to be a data attribute (@public)
        closeBtnCls = "remove-row-btn";

    $.fn.exists = function () {
        return this.length !== 0;
    };

    function init() {
        scope.event = e;
        scope.button = $(scope).find(buttonID);
        
        if (scope.rowTotal === undefined) {
            scope.rowTotal = $(scope).find("[" + templateID + "]").length;
        }

        if (!e) {
            return;
        }

        // If not a button, then return
        if (!scope.button.exists() || scope.event.target !== scope.button[0]) {
            return;
        }

        e.preventDefault();
        getTemplate();
    }

    /**
     * Grabs defines section of entry to copy (data-template)
     */
    function getTemplate() {
        var entry = e.currentTarget,
            tmpTemplate,
            cleanType = false;

        // In case clickthrough for entry is defined (via "pointer-events: none", maybe)
        if (entry === scope.button) {
            entry = entry.parent;
        }

        if (!$(entry).exists()) {
            return;
        }

        // Store template temporarily to query certain values
        tmpTemplate = $(entry).find("[" + templateID + "]").first();
        scope.template = tmpTemplate.clone();

        // If hidden, assume is first template
        if (tmpTemplate.hasClass("hide")) {
            // Swap
            cleanType = true;
            tmpTemplate.remove();
        }

        if (!scope.template.exists()) {
            return;
        }

        cleanTemplate(cleanType);
        bindCloseEvent(scope.template);
        add();
    }

    /**
     * Removes any values or other custom data from template
     * @param {boolean} type defines if first template (true) or not
     */
    function cleanTemplate(type) {
        scope.template
            .attr(templateID, type)
            .removeClass("hide")
            .find("." + closeBtnCls).remove();

        $.each(scope.template.find("input"), function () {
            $(this).val("");
        });

        $.each(scope.template.find("select"), function () {
            $(this).children().first().attr("selected", true);
        });
    }

    /**
     * Adds element to remove inserted row, if necessary
     * @public
     * @param {object} ele the element to append the close button to
     *        (Added so event can be bound to elements that weren't created by this class)
     */
    function bindCloseEvent(ele) {
        var closeBtn = $("<div>", {
            "class": closeBtnCls,
            "html": "<a>Remove</a>"
        }).on("click", remove);

        ele.append(closeBtn);
    }

    /**
     * Hides and disables row element
     * @public
     * @param {object} ele the element to hide
     */
    function hideRow(ele) {
        ele.addClass("hide");
        toggleDisabledInputs(ele, true);
    }

    /**
     * Shows and enables row element
     * @public
     * @param {object} ele the element to show
     */
    function showRow(ele) {
        ele.removeClass("hide");
        toggleDisabledInputs(ele, false);
    }

    /**
     * Toggles disabled attribute for inputs in node (to define whether they should POST data)
     * @param {object} parent node
     * @param {string} toggle whether inputs is to be disabled (TRUE) or not
     */
    function toggleDisabledInputs(parent, toggle) {
        $.each(parent.find("input, textarea, select"), function () {
            $(this).attr("disabled", toggle);
        });
    }

    /**
     * Adds new row, before the button
     */
    function add() {
        scope.template.insertBefore(scope.button);
        showRow(scope.template);
        checkLimit(1);
    }

    /**
     * Removes row via close button event
     * @param {object} e click event
     */
    function remove(e) {
        var eleToRemove = $(e.target).parent().parent();

        if (Boolean(eleToRemove.attr(templateID)) !== false) {
            // Only hides the first instance so we can copy later
            hideRow(eleToRemove);
        } else {
            eleToRemove.remove();
        }
        checkLimit(-1);
    }
    
    function checkLimit(dir) {
        scope.rowTotal += dir;

        if (scope.rowTotal < rowLimit) {
            $(scope).find(buttonID).removeClass("hide");
        } else {
            $(scope).find(buttonID).addClass("hide");
        }
    }

    init();

    return {
        "templateNode": template,
        "buttonID": buttonID,
        "templateID": templateID,
        "bindCloseEvent": bindCloseEvent,
        "showRow": showRow,
        "hideRow": hideRow
    };
};

$(document).ready(function () {
    "use strict";
    
    $("body").on("click", "[data-profile-entry]", AddRow);

    bindRowEvents($(document).find("[data-profile-entry]"));
});

/**
 * Global method to append events on existing elements
 * @param {object} containers attribute noting elements containing nodes to bind event to
 */
function bindRowEvents(containers) {
    "use strict";

    var obj = new AddRow(),
        container,
        rows,
        toggles;

    $.each(containers, function () {
        container = $(this);
        rows = container.find("[" + obj.templateID + "]");
        toggles = container.find("[data-profile-toggle]").find("input[type=\"radio\"]");

        $.each(rows, function () {
            obj.bindCloseEvent($(this));
        });

        toggles.on("click", addToggleEvent(container));
    });

    function addToggleEvent(curContainer) {
        return function () {
            var curRows  = curContainer.find("[" + obj.templateID + "]"),
                curEvent = $(this);

            if (curEvent.val() == 1) {
                obj.showRow(curRows);
                curContainer.find(obj.buttonID).removeClass("hide");
            } else {
                obj.hideRow(curRows);
                curContainer.find(obj.buttonID).addClass("hide");
            }
        };
    }
}
